module.exports = __webpack_public_path__ + "img/lawn_and_garden_care.5c1c2283.jpg";